// Re-export enums from et-ui for convenience
export {
  CheckboxVariant,
  SearchVariant,
  Size,
  ButtonTheme,
} from "@ever-tutor/et-ui";

// Local enums not exported by et-ui
export enum CaretPosition {
  TOP = "top",
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
}
